import React from 'react';
export function Footer() {
  return <footer className="bg-background py-12 border-t border-white/5" data-id="element-69">
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-70">
        <div className="text-2xl font-serif font-medium tracking-widest uppercase text-ivory flex items-center gap-2" data-id="element-71">
          <span className="text-gold" data-id="element-72">A</span>ura
        </div>

        <div className="flex gap-6 text-sm font-sans uppercase tracking-widest text-ivory/50" data-id="element-73">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-74">
            Instagram
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-75">
            Facebook
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-76">
            LinkedIn
          </a>
        </div>

        <div className="text-xs font-sans text-ivory/30 uppercase tracking-widest" data-id="element-77">
          &copy; {new Date().getFullYear()} Aura Events. All rights reserved.
        </div>
      </div>
    </footer>;
}